var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgChat = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M3.418 14.844c.046-.171-.057-.409-.155-.58q-.045-.078-.099-.149a7.8 7.8 0 0 1-1.289-4.297c-.014-4.385 3.622-7.943 8.118-7.943 3.922 0 7.195 2.717 7.96 6.323.114.534.172 1.08.172 1.626 0 4.391-3.496 8.005-7.992 8.005-.715 0-1.68-.18-2.206-.327a15 15 0 0 1-1.187-.395 1.22 1.22 0 0 0-.906.014l-2.65.957a.6.6 0 0 1-.182.047.373.373 0 0 1-.374-.38.6.6 0 0 1 .023-.129z"
  })));
};
export { SvgChat as ReactComponent };